import { useStaticQuery, graphql } from 'gatsby'

export const useHirschbergCaresQuery = () => {
  const { wpPage } = useStaticQuery(graphql`
    query HirschbergCaresQuery {
      wpPage(title: { eq: "Home" }) {
        hirschbergCares {
          hirschbergCares {
            title
            text
            tabs {
              label
              image {
                localFile {
                  childImageSharp {
                    gatsbyImageData(formats: [WEBP], sizes: "(min-width: 1024px) 43vw, 90vw")
                  }
                }
              }
              altText
              title
              text
              link {
                title
                url
              }
            }
          }
        }
      }
    }
  `)
  return wpPage.hirschbergCares.hirschbergCares
}
